// Anything served from koi.tech is a deployed environment and must never resolve to
// localhost, even when the bundle was built in development mode. Keeping the hostname in
// this expression also stops the production endpoints from being tree-shaken out of a
// development-mode build.
const isDeployedHostname = window.location.hostname.endsWith('koi.tech');
const isDevelopment = import.meta.env.DEV && !isDeployedHostname;

const localURL = 'http://localhost:8058';
// Through the load balancer, never the run.app URL: forms-api's ingress admits only the load balancer.
const prodURL = window.location.hostname.match('staging')?.length ? 'https://staging-forms-api.koi.tech' : 'https://forms-api.koi.tech';

const API_VERSION = 'v1';
const development = {
  API_URL: `${localURL}/api/${API_VERSION}`,
};

const production = {
  API_URL: `${prodURL}/api/${API_VERSION}`,
};

export const API_URL = isDevelopment ? development.API_URL : production.API_URL;
